import React, { PureComponent } from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import locales from '../../../../../locales'

class OrderItems extends PureComponent {

  constructor (props) {
    super(props)
    this.localesAsObject = {}
    for (let locale of locales) {
      this.localesAsObject[locale.shortLocale] = locale
    }
  }

  createResultRow (key, item) {
    const { t } = this.props

    return (
      <tr key={key}>
        <td data-title={'GIATA-ID'}>{item.giataId}</td>
        <td data-title={t('HOTEL')}>{item.hotelName}</td>
        <td data-title={t('CITY')}>{item.cityName}</td>
        <td data-title={t('COUNTRY')}>{item.countryName}</td>
        <td data-title={t('NUMBER_OF_ROOMS')}>{item.numberOfRooms}</td>
        <td data-title={t('ITEM_FEATURE_ADDITIONAL')}>{item.additionalFeatures === true ? t('YES') : t('NO')}</td>
      </tr>
    )
  }

  render () {
    const { t } = this.props
    return (
      <div className="flex-table order-items" style={{ flex: 1 }}>
        <div style={{ position: 'relative' }} className="table-responsive-vertical">
          <table className="table table-hover table-mc-light-blue Gradient">
            <thead>
            <tr>
              <td>GIATA-ID</td>
              <td>{t('HOTEL')}</td>
              <td>{t('CITY')}</td>
              <td>{t('COUNTRY')}</td>
              <td>{t('NUMBER_OF_ROOMS')}</td>
              <td>{t('ITEM_FEATURE_ADDITIONAL')}</td>
            </tr>
            </thead>
            <tbody>
            {Object.keys(this.props.orderItems).map((key) => this.createResultRow(key, this.props.orderItems[key]))}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

OrderItems.propTypes = {
  orderItems: PropTypes.array.isRequired
}

export default withTranslation()(OrderItems)
